import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import KrakenShareButton from '@fastnorth/kraken/components/share-button';

type ShareButtonProps = {
  trackingLocation: 'hamburger_menu' | 'finisher_cert';
};

const ShareButton = ({ trackingLocation }: ShareButtonProps): ReactElement => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.components.share_button' });
  return (
    <KrakenShareButton
      aria-label={t('share')}
      copiedLabel={t('link_copied')}
      shareTitle={document.title}
      shareUrl={window.location.href}
      trackingLocation={trackingLocation}
    />
  );
};

export default ShareButton;
